<template>
  <footer class="footer px-4">
    <!--<div class="row align-items-center justify-content-lg-between">-->
      <!--<div class="col-lg-12">-->
        <!--<div class="copyright text-center text-lg-left text-muted">-->
          <!--© {{year}} <a href="https://www.creative-tim.com" class="font-weight-bold ml-1" target="_blank">San Roque Balompie</a>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
